import maschine from './maschine';

export default {
  maschine,
};
